export const ENTITYTYPE_VACANCY = 'ENTITYTYPE_VACANCY'
export const ENTITYTYPE_APPLICANT = 'ENTITYTYPE_APPLICANT'
export const ENTITYTYPE_CANDIDATE = 'ENTITYTYPE_CANDIDATE'
